export class FilesUploadController {
  isUploading = false;
  private currentlyUploading = 0;
  private maxParalelUploads = 2;
  private uploadPromise: Promise<boolean> = null;
  private uploadPromiseResolve: (uploaded: boolean) => void = null;
  private filesToUpload: { (): Promise<void> }[] = [];

  uploadFile(upload: () => Promise<void>) {
    this.filesToUpload.push(upload);
    this.processUpload();
  }

  async waitForUpload(): Promise<boolean> {
    if (this.isUploading)
      return this.uploadPromise;
    else
      return Promise.resolve(true);
  }

  private processUpload() {
    while (this.filesToUpload.length > 0 && this.currentlyUploading < this.maxParalelUploads) {
      this.currentlyUploading++;
      if (!this.isUploading) {
        this.isUploading = true;
        this.uploadPromise = new Promise((resolve) => { this.uploadPromiseResolve = resolve; });
      }
      const upload = this.filesToUpload.shift();
      upload().finally(() => {
        this.currentlyUploading--;
        this.processUpload();
      });
    }
    if (this.currentlyUploading === 0 && this.filesToUpload.length === 0) {
      this.isUploading = false;
      if (this.uploadPromiseResolve != null)
        this.uploadPromiseResolve(true);
    }
  }
}
